import orderBy from 'lodash/orderBy';

const client = (state = {}, action) => {
  switch (action.type) {
    case 'CLIENT_PROJECTS':
      return {
        ...state
      };
    case 'PROJECT_PAGE':
    return {
      ...state,
      // user: action.payload[0].user,
      appLoaded: true,
      projects: orderBy(action.payload[1].projects, ['created_at'],['desc']),
      companies: action.payload[1].companies,
      user: action.payload[0].user
    }
    case 'PROJECT_PAGE_UNLOADED':
    return {}

    case 'PROJECT_SETTINGS_PAGE':
    // console.log('RESULT', action.payload)
      return {
        project: action.payload.project,
        companies: action.payload.companies
      }
    case 'UPDATE_PROJECT_SETTINGS':
      return {
        ...state,
        updateSuccess: action.payload.project && true,
        project: action.payload.project
      }
    case 'LOAD_PROJECT_CONFIRMATION':
    case 'LOAD_DASHBOARD':
      if (action.payload.project && action.payload.project.pubreg_data) {
        // Store on q_jwt
        if (window.localStorage.getItem('q_jwt'))
          window.localStorage.removeItem('q_jwt')
        window.localStorage.setItem('q_jwt', action.payload.project.pubreg_data.questions_answers)
      }
      return {
        ...action.payload
      }
    case 'COMPANY_LANDING_PAGE':
      return {
        projects: action.payload[0].projects,
        company: action.payload[1].company
      }
    case 'COMPANY_LANDING_PAGE_DETAILS':
      return {
        project: action.payload[0].project
      }
    default:
      return state;
  }
};


export default client


// WEBPACK FOOTER //
// ./src/reducers/client.js